

// //toast
// import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

// //msg_modal
// //消息通知
// import msg_modal from '@/components/MsgModal';


//invite_modal
//助力邀请
import invite_modal from '@/components/InviteModal';

//copy_modal
//复制
import copy_modal from '@/components/CopyModal';

//invite_apply
//邀请确认
import invite_apply from '@/components/InviteApply';

// msg_Modal
import msg_modal from '@/components/MsgModal';

let utils = {
    // $toast: toast,
    $bind_modal : bind_modal,
    $invite_modal : invite_modal,
    $copy_modal : copy_modal,
    $invite_apply : invite_apply,
    $msg_modal : msg_modal,
}

export default utils;